import React, { useMemo } from "react";
import { usePostTags, useCurrentPost } from "../../hooks";

export default function TagSelect({
  sendUpdates = true,
  onUpdate = null,
  currentTags = null,
}) {
  const { currentPost, fetchData } = useCurrentPost();

  const { getNewTagFromUser, tags, updateTagsForCurrentPost } = usePostTags({
    initialize: !sendUpdates,
  });

  const onPostTagSelect = async ({ target: { value } }) => {
    const nextTag = await getNewTagFromUser({ value });
    if (nextTag && sendUpdates) {
      await updateTagsForCurrentPost({
        nextTag,
      });
    }
    if (onUpdate) {
      onUpdate({ nextTag });
    }
    await fetchData({ showEditButton: true });
  };

  const tagOptions = useMemo(() => {
    const currentTagsToUse = currentTags ? currentTags : currentPost.tags;
    return (tags || [])
      .filter(
        (tag) => !currentTagsToUse || !currentTagsToUse.includes(tag.name)
      )
      .map((tag) => (
        <option
          style={{ fontWeight: 800, color: tag.color }}
          key={tag.name}
          id={tag.name}
          value={tag.name}
        >
          {tag.name}
        </option>
      ));
  }, [tags, currentPost, currentTags]);

  return (
    <>
      <label htmlFor="post-Editor tag-select">Tags</label>
      <br />
      <select id="post-tag-select" value="--" onChange={onPostTagSelect}>
        <option default id="null" value="--">
          ---
        </option>
        <option id="new-tag" value="NEW">
          Create new tag
        </option>
        {tagOptions}
      </select>
    </>
  );
}
